<shared-external-cmr-agent-bar [showButtonBack]="showButtonBack" [tenantId]="tenantId"
    (clickBack)="onClickBack()"></shared-external-cmr-agent-bar>
<ng-container *ngIf="!phaseUUID">
    <div class="block-center">
        <div class="header"></div>
        <div class="nouuid">
            No valid uuid
        </div>
    </div>
</ng-container>

<div class="container qrcmr" *ngIf="phaseUUID">
    <div class="block-center">
        <shared-external-cmr-agent-phase [agent]="'consignee'" [phaseUUID]="phaseUUID" [optionExpanded]="optionExpanded" (optionExpandedChanged)="onOptionExpandedChanged($event)"></shared-external-cmr-agent-phase>
    </div>
</div>
<div class="signaturahardman">
    <img class="logoimg" src="/assets/images/HardmanLogoBlanc.png" alt="Hardman logo">
    <a href="https:hardman.app" target="_blank" class="powered">{{'GLOBAL.DESENVOLUPATPER' | translate}}</a>
</div>